'use strict';

export function icitNavigation() {
	const primaryNav = document.querySelector('nav li.mega-submenu-default');

	if (!primaryNav) {
		return false;
	}

	const megaSubmenus = document.querySelectorAll(
		'nav li.mega-submenu-default'
	);

	megaSubmenus.forEach((item) => {
		const link = item.querySelector('a');

		link.addEventListener('click', (e) => {
			e.preventDefault();

			megaSubmenus.forEach((el) => {
				if (
					el === item &&
					el.getAttribute('aria-expanded') !== 'true'
				) {
					el.setAttribute('aria-expanded', 'true');
				} else {
					el.setAttribute('aria-expanded', 'false');
				}
			});
		});
	});
}

export function icitToggleSubmenu( element ) {
	const submenu = element.querySelector('.sub-menu .sub-menu-inner');

	if (!submenu) return;

	// Get the bounding rects
	const liRect = element.getBoundingClientRect();
	const submenuRect = submenu.getBoundingClientRect();

	// Calculate the remaining width to the right edge of the viewport
	const remainingWidth = ( window.innerWidth - 40 ) - liRect.left;

	// Check if the submenu fits within the remaining width
	if (submenuRect.width > remainingWidth) {
		submenu.style.transform = `translateX(-${submenuRect.width - remainingWidth + 0}px)`;
	} else {
		submenu.style.transform = '';
	}
}